module.exports = __webpack_public_path__ + "img/integrationicon.f3686f77.svg";